import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { IAppFile } from '@portal/marketplace/api-interfaces';
import { SwiperOptions } from 'swiper/types';
import { register } from 'swiper/element/bundle';
import { ElementRef } from '@angular/core';

register();
@Component({
    selector: 'marketplace-app-screen-carousel',
    templateUrl: './app-screen-carousel.component.html',
    styleUrls: ['./app-screen-carousel.component.scss'],
    standalone: false
})
export class AppScreenCarouselComponent implements OnInit, AfterViewInit  {
  @Input() images: IAppFile[];
  @Input() isDeleteAbility = true;
  @Output() deleteImageEvt: EventEmitter<IAppFile> = new EventEmitter();
  @Input() isPublic = false;

  @ViewChild('privateSwiper') privateSwiperRef!: ElementRef;
  @ViewChild('publicSwiper') publicSwiperRef!: ElementRef;
  config: SwiperOptions = {
    centerInsufficientSlides: true,
    watchOverflow: true,
    pagination: {
      clickable: true,
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
    },
  };

  constructor() {}

  deleteImage(img: IAppFile): void {
    this.deleteImageEvt.emit(img);
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const privateSwiper: any = this.privateSwiperRef.nativeElement;
    Object.assign(privateSwiper, this.config);
    privateSwiper.initialize();

    const publicSwiper: any = this.publicSwiperRef.nativeElement;
    Object.assign(publicSwiper, this.config);
    publicSwiper.initialize();
  }
}